export default "__VITE_ASSET__Qp8zUiLJ__"